import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_eow5j1bbc8: FaireBrandEntity = {
  token: "b_eow5j1bbc8",
  type: "brand",
  name: "Ellison+Young",
  avatarUrl:
    "https://cdn.faire.com/fastly/615b89c059dac7bfd521b1b10174a25c2b31d1c16bef8eeef542de8b1dcf5ff4.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/d63d81f2ff9d55f7389e483569a4f59a31999b933242bf2d1c247eeb2ba454cf.png",
  logoUrl:
    "https://cdn.faire.com/fastly/615b89c059dac7bfd521b1b10174a25c2b31d1c16bef8eeef542de8b1dcf5ff4.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d63d81f2ff9d55f7389e483569a4f59a31999b933242bf2d1c247eeb2ba454cf.png",
  location: "Alpharetta, GA, USA",
  minimumOrderDollars: 50,
  rating: 4.9,
  reviewCount: 2885,
  isTopShop: true,
  isInsider: true,
  description:
    "Ellison+Young is the contemporary brand with retail eyes. After running retail boutique stores for more than a decade, we decide to launch our own brand that meets the market and understand the need of retail stores. \n\nWe design Jewelry with nicely designed package so that it can be sold to each customer for herself or presented as a gift. \n\nWe also carry fashion accessories, hair accessories, gifts and other interesting lifestyle products.\n\nAll packages will be shipped out of Georgia. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:46.426Z",
    importedBy: "entity-db-cli",
  },
};
